const module = { name: 'mps', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';

exports.AdTypes = Object.freeze({
    BANNER: 'banner',
    BANNER_MID: 'bannermid2',
    INTERSTITIAL: 'Interstitial',
    LOCKED_BANNER_BOTTOM: 'lockedbannerbottom',
});


const POLL_INTERVAL_MS = 250


const MAX_ATTEMPTS = 15000 / POLL_INTERVAL_MS


const listeners = []


let numAttempts = 0


let timeoutID


const noop = () => null
function getMPS() {
    const { mps } = window;
    return Object.assign({
        isAvailable: Boolean(mps && typeof mps.insertAd === 'function'),
        getAd: noop,
        insertAd: noop,
        refreshAds: noop,
    }, mps);
}
function retryLoad() {
    const mps = getMPS();
    if (!mps.isAvailable) {
        numAttempts++;
        if (numAttempts <= MAX_ATTEMPTS) {
            clearTimeout(timeoutID);
            timeoutID = setTimeout(retryLoad, POLL_INTERVAL_MS);
            return;
        }
        debugLog.warn(module.name, 'load failed');
    }
    while (listeners.length) {
        const eventHandler = listeners.pop();
        eventHandler(mps);
    }
}
exports.onLoad = (eventHandler) => {
    if (typeof eventHandler !== 'function' || eventHandler.length < 1) {
        throw new Error(`${module.name}.onLoad event hander must be a function`);
    }
    listeners.push(eventHandler);
    retryLoad();
};
export default module.exports;